import { render, staticRenderFns } from "./HistoryPrescription.vue?vue&type=template&id=ae77b10a&scoped=true&"
import script from "./HistoryPrescription.vue?vue&type=script&lang=js&"
export * from "./HistoryPrescription.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPrescription.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HistoryPrescription.vue?vue&type=style&index=1&id=ae77b10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae77b10a",
  null
  
)

export default component.exports